module.exports = __webpack_public_path__ + "img/ningboyh.0ab8bd61.png";